import { render } from "./AdminUnitsView.vue?vue&type=template&id=225feeb6"
import script from "./AdminUnitsView.vue?vue&type=script&lang=js"
export * from "./AdminUnitsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__